<script setup>
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  items: {
    type: Array,
    required: true,
  },
})
</script>

<template>
  <div class="row slider">
    <div class="col-12">
      <div class="slider__content">
        <h2
          v-if="props.title"
          class="scale-2 scale-2--bold"
        >
          {{ props.title }}
        </h2>
      </div>
      <div class="slider__slider">
        <Slider
          :show-pagination="true"
          :wrap-around="true"
          :slides="props.items"
          class="slider--overflow slider--fade-out"
        >
          <template #default="slide">
            <SlideImage
              :slide="slide"
              class="slide__zoom"
            />
          </template>
        </Slider>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.slider {
  &__content {
    margin-bottom: 35px;
    width: 66%;

    @include media-breakpoint-down(640) {
      margin-bottom: 28px;
      width: 100%;
    }
  }

  &__slider {
    :deep(.embla__slide) {
      height: clamp(160px, 3.82vw + 147.78px, 215px);
    }
  }
  :deep(.embla__slide) {
    flex: 0 0 83.333%; /* Default slide covers 100% of the viewport */
  }
  @media (min-width: 560px) {
    :deep(.embla__slide) {
      flex: 0 0 66.667%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }
  @media (min-width: 800px) {
    :deep(.embla__slide) {
      flex: 0 0 45.454%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }
  @media (min-width: 1200px) {
    :deep(.embla__slide) {
      flex: 0 0 28.571%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }
}
</style>
